import CompletePage from '../complete/CompletePage'
import ConfirmAllowancesPage from '../confirm/ConfirmAllowancesPage'

export default function ReviewAcceptedPage () {
  return (
    <CompletePage reviewingAcceptedQuote>
      <ConfirmAllowancesPage reviewingAcceptedQuote />
    </CompletePage>
  )
}
